import { defineComponent as _defineComponent } from 'vue';
import { DocumentTypeEnum } from 'wklr-backend-sdk/models';
import Icon from '@/components/renewal/common/icon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'search-tabs',
  props: {
    selectedDocType: null
  },
  emits: ['changeDocType'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var docTypes = ref([{
      label: '書籍・雑誌',
      value: 'book'
    }, {
      label: 'ガイドライン等',
      value: 'guideline'
    }, {
      label: 'パブコメ',
      value: 'public-comment'
    }, {
      label: '法令',
      value: 'law'
    }]);
    var iconName = function iconName(docType) {
      switch (docType) {
        case 'book':
          return DocumentTypeEnum.Book;
        case 'guideline':
          return DocumentTypeEnum.Guideline;
        case 'public-comment':
          return DocumentTypeEnum.Pubcom;
        case 'law':
          return DocumentTypeEnum.Law;
      }
    };
    var selectDocType = function selectDocType(docType) {
      emit('changeDocType', docType);
    };
    return {
      __sfc: true,
      emit: emit,
      docTypes: docTypes,
      iconName: iconName,
      selectDocType: selectDocType,
      Icon: Icon
    };
  }
});